// NPM Imports
import React, { Fragment } from "react";

// Internal Imports
import { NumberInput, Toastr } from "../../../revvComponents";
import { BasePriceNotifier } from "../Display/Renderer";

export default class RevvGridCurrency extends React.Component {
  state = {
    cellValue: 0,
    localUpdate: false,
    showComponent: false,
  };

  componentDidMount() {
    const { row, field } = this.props;
    const cellValue = row.rowData[field] ? row.rowData[field].cellData : "";
    this.setState({ cellValue });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { row, field } = nextProps;
    const cellValue = row.rowData[field] ? row.rowData[field].cellData : "";
    if (!prevState.localUpdate && cellValue !== prevState.cellValue) {
      return { cellValue };
    }
    return null;
  }

  _onChange = value => {
    this.setState({ cellValue: value, localUpdate: true });
  };

  _onBlur = () => {
    const { field, row } = this.props;
    const minValue =
      (row.rowData[field] &&
        row.rowData[field].cellMeta &&
        row.rowData[field].cellMeta.minValue) ||
      1;

    if (parseFloat(this.state.cellValue) >= minValue) {
      this.props.onChange(parseFloat(this.state.cellValue));
      this.setState({ showComponent: false, localUpdate: false });
    } else {
      this.setState({
        cellValue: 1,
        showComponent: false,
        localUpdate: false,
      });
      Toastr.showToastr({
        type: "warning",
        message: `Enter value greater or equal to ${minValue}`,
        timeout: 3000,
      });
    }
  };

  render() {
    const { field, row, ...otherProps } = this.props;
    const editable =
      row.rowData[field] &&
      row.rowData[field].cellMeta &&
      row.rowData[field].cellMeta.editable;
    const isBasePriceDynamic =
      row.rowData[field] &&
      row.rowData[field].cellMeta &&
      row.rowData[field].cellMeta.isBasePriceDynamic;
    return (
      <Fragment>
        {this.state.showComponent && (
          <NumberInput
            isFloat
            onBlur={this._onBlur}
            onChange={this._onChange}
            onKeyPress={event => {
              if (event.key === "Enter") {
                this._onBlur();
              }
            }}
            placeholder="Currency"
            value={this.state.cellValue}
            data-test="rgcurrency-number-input"
          />
        )}
        {!this.state.showComponent && (
          <BasePriceNotifier
            editable={editable}
            isBasePriceDynamic={isBasePriceDynamic}
            onClick={() => this.setState({ showComponent: true })}
            rowMeta={row.rowMeta}
            value={this.state.cellValue}
            {...otherProps}
          />
        )}
      </Fragment>
    );
  }
}
